import axios from "axios";
import { toast } from "react-toastify";
import { getAuthToken } from "./cookieUtils";

const axiosInstance = axios.create({
  timeout: 30000,
});

let isHandlingTokenExpiration = false;

const handleSessionConflict = () => {
  if (isHandlingTokenExpiration) return;
  isHandlingTokenExpiration = true;

  sessionStorage.setItem('axios_handled_session_conflict', 'true');

  localStorage.clear();
  sessionStorage.clear();

  toast.error(
    "Your session has expired. This may be because someone else logged in with your account.", 
    {
      position: "top-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      toastId: 'session-conflict', // Prevent duplicates
    }
  );

  // Go back to login
  setTimeout(() => {
    window.location.href = "/login";
  }, 5000);
};

axiosInstance.interceptors.request.use(
  (config) => {
    const token = getAuthToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    return response; // Everything is fine
  },
  (error) => {
    const { response } = error;
    
    if (response && (response.status === 401 || response.status === 403)) {
      const isNaturalLogout = sessionStorage.getItem('natural_logout') === 'true';
      
      if (!isNaturalLogout) {
        handleSessionConflict();
      }
    }
    
    if (!response && error.request) {
      toast.error("Network error. Please check your internet connection.");
    }
    
    return Promise.reject(error);
  }
);

export const setupDefaultAxiosInterceptors = () => {
  axios.interceptors.request.use(
    (config) => {
      const token = getAuthToken();
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      const { response } = error;
      
      if (response && (response.status === 401 || response.status === 403)) {
        const isNaturalLogout = sessionStorage.getItem('natural_logout') === 'true';
        
        if (!isNaturalLogout) {
          handleSessionConflict();
        }
      }
      
      return Promise.reject(error);
    }
  );
};

export default axiosInstance;